import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { EntityState } from '@api/models/enums/EntityState';
import { EstablishmentDto } from '@api/models/establishment/EstablishmentDto';
import { establishmentService } from '@api/services/services';

export interface AllEstablishmentListFilter extends ListFilter {
  state?: EntityState;
}

export type AllEstablishmentListState = ListType<EstablishmentDto, AllEstablishmentListFilter>;

const initialState: AllEstablishmentListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    state: EntityState.Active,
    sortBy: 'name',
    sortDesc: false,
  },
};

export const allEstablishmentListSlice = listSlice({
  name: 'allEstablishmentList',
  initialState,
});

export const selectAllEstablishmentList = (state: RootState) => state.allEstablishmentList;
export const allEstablishmentListActions = allEstablishmentListSlice.actions;

export const getAllEstablishmentList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectAllEstablishmentList(storeState);

  const handleGetData = (size: number) => {
    return establishmentService.queryAllEstablishments({
      q: data.query.q,
      state: data.query.state,
      page: data.query.page,
      size: size,
      sort: getListSort(data)},
      { cancelToken: cancelToken as any }
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: allEstablishmentListActions,
    getData: handleGetData,
  });
};
